import React from 'react'

export function useForceUpdate() {
  const [forceUpdateKey, increment] = React.useState(0)
  const forceUpdate = React.useCallback(() => {
    increment((prev) => prev + 1)
  }, [])
  return { forceUpdate, forceUpdateKey }
}
